import type { ReactNode } from "react"
import type { TUser } from "@/types"
import { buildUserURL } from "@/utils"
import { AppLink, type TAppLinkProps } from "../utils"

export function UserLink({
  user,
  children,
  ...props
}: { user: TUser; children: ReactNode } & Omit<TAppLinkProps, "href">) {
  return (
    <AppLink href={buildUserURL(user.id)} {...props}>
      {children}
    </AppLink>
  )
}
